import { render, staticRenderFns } from "./Produktreiter.vue?vue&type=template&id=07965ef1"
import script from "./Produktreiter.vue?vue&type=script&lang=js"
export * from "./Produktreiter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports